// extracted by mini-css-extract-plugin
export default {"link":"link_link__E+Q+P","icon":"link_icon__24kbR","linkContent":"link_linkContent__m7ReL"};